import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { httpsCallable } from "firebase/functions";
import { getFunctions } from "firebase/functions";
import { db } from "../../firebase";
import { deleteDoc, doc } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";

const DeleteUserModal = (props) => {
  const functions = getFunctions();
  const [isLoading, setIsLoading] = useState(false);

  const deleteUserFunction = httpsCallable(functions, "deleteUser"); // Renommé deleteUserFunction

  const handleDeleteUser = async () => {
    // Fonction asynchrone
    setIsLoading(true);
    try {
      // Effacer l'utilisateur de l'authentification
      await deleteUserFunction({ uid: props.uid });

      // Effacer les données de l'utilisateur de Firestore

      const userDoc = doc(db, "roles", props.uid);
      await deleteDoc(userDoc);

      // Afficher un toast de succès
      showCustomToast("User deleted successfully.", "success");

      setIsLoading(false);
      props.onClose();
    } catch (error) {
      // Une erreur s'est produite lors de la suppression de l'utilisateur
      console.error("Error deleting user: ", error);
      setIsLoading(false);

      // Afficher un toast d'erreur
      showCustomToast("Error deleting user.", "error");
    }
  };

  return (
    <div className="roles-modal roles-modal-danger">
      <div className="roles-modal-header">
        <div>
          <div className="roles-modal-title">Delete user</div>
          <div className="roles-modal-subtitle">
            {props.userName || props.userEmail || props.uid}
          </div>
        </div>
        <button
          type="button"
          className="roles-modal-close"
          onClick={props.onClose}
          aria-label="Close delete user modal"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      <div className="roles-modal-body">
        <div className="roles-delete-warning">
          <div className="roles-delete-title">This action cannot be undone.</div>
          <div className="roles-delete-copy">
            The user account and its role document will be deleted.
          </div>
          <div className="roles-delete-meta">{props.userEmail || props.uid}</div>
        </div>
      </div>

      <div className="roles-modal-footer">
        <Button
          variant="outlined"
          onClick={props.onClose}
          disabled={isLoading}
          className="roles-modal-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isLoading}
          onClick={handleDeleteUser}
          className="roles-modal-delete"
        >
          {isLoading ? "Deleting..." : "Delete user"}
        </Button>
      </div>
    </div>
  );
};

export default DeleteUserModal;
